import {classMap} from 'lit-html/directives/class-map';
import {until} from 'lit-html/directives/until';
import '@modules/auth-context';
import {summaryLabels, generalLabels, generalAriaLabels} from '@modules/i18n-labels';
import {permissions} from '../constants-enumerate';
import {hasOneOfPermissions} from '@modules/permissions';
import {repeat} from 'lit-html/directives/repeat.js';

export default (ctx, html) => {
  const viewText = ctx.__('<tt-gWtZ9jNj>', 'View');
  return html`
    <div class="row no-gutters">
      ${repeat(ctx.summary, (item) => item.type, (item, index) => html`
        <div class="col-12 col-md-6 col-lg-4 pr-5 mb-4 type-${item.type}">
          <div class="${classMap(ctx.cardClasses[index % ctx.cardClasses.length])}">
            <div class="d-flex pl-2 justify-content-between">
              <div>
                ${ctx.loading ? html`<div class="spinner-border" role="status"><span class="sr-only">${until(generalLabels.loading)}</span></div>` : html`<h3 class="m-0">${item.qty}</h3>`}
                <p class="m-0">${summaryLabels[item.label] ? until(summaryLabels[item.label]) : item.label}</p>
              </div>
              <div class="d-flex align-items-end justify-content-between pl-2">
                ${!ctx.isThirdPartyConnected ? html`
                  <auth-context show-on-auth .permissions="${item.permissions}">
                    <div class="d-flex flex-column flex-sm-row">
                      <div class="ai ai-create w-50 m-auto text-center"></div>
                      <a aria-label="${until(generalAriaLabels.createLabel(item.label))}" class="btn btn-link card-nowrap text-body pb-0" href="${item.urls.create}" data-bi-id="create_${item.type}"> ${until(generalLabels.create)}</a>
                    </div>
                  </auth-context>
                  `: html`
                    <auth-context show-on-auth .permissions="${item.permissions}">
                      <div class="d-flex flex-column flex-sm-row">
                        <small class="ai ai-create w-50 m-auto text-center"></small>
                        <a aria-label="${until(generalAriaLabels.createLabel(item.label))}" class="btn btn-link card-nowrap text-muted pb-0" ?disabled="${item.urls.create}" data-bi-id="create_${item.type}"> ${until(generalLabels.create)}</a>
                      </div>
                    </auth-context>
                  `}
                ${!hasOneOfPermissions([permissions.SPONSOR, permissions.HIDE_STUDENT]) && ctx.userType === 'teacher' ? html`
                  ${item.label !== 'teachers' ? html`
                    <div class="d-flex flex-column flex-sm-row">
                      <small class="ai ai-chevron-right w-50 m-auto text-center"></small>
                      <a aria-label="${until(generalAriaLabels.viewLabel(item.label))}" class="btn btn-link card-nowrap text-body pb-0" href="${item.urls.manage}" data-bi-id="view_${item.type}"> ${until(viewText)}</a>
                    </div>
                    ` : ``}
                `: html`
                  <div class="d-flex flex-column flex-sm-row">
                    <small class="ai ai-chevron-right w-50 m-auto text-center"></small>
                    <a aria-label="${until(generalAriaLabels.viewLabel(item.label))}" class="btn btn-link card-nowrap text-body pb-0" href="${item.urls.manage}" data-bi-id="view_${item.type}"> ${until(viewText)}</a>
                  </div>
                `}
              </div>
            </div>
          </div>
        </div>
      `)}
    </div>
`};
